export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-26-C-front-side-back-twist-WEB-Large-98f26ce97700f194a060ed6fb8f52333.jpg";